import { render, staticRenderFns } from "./CustomContent.vue?vue&type=template&id=5e67b867&"
import script from "./CustomContent.vue?vue&type=script&lang=js&"
export * from "./CustomContent.vue?vue&type=script&lang=js&"
import style0 from "./CustomContent.vue?vue&type=style&index=0&id=5e67b867&prod&lang=css&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports